export default function SvgMovies() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M28.951 28.4545C26.7612 28.4545 24.9795 26.6728 24.9795 24.4831C24.9795 24.4786 24.9771 24.4746 24.9771 24.4701C27.4364 21.8862 28.951 18.3948 28.951 14.5544C28.951 6.61648 22.4924 0.157898 14.5545 0.157898C6.61654 0.157898 0.157959 6.61648 0.157959 14.5544C0.157959 22.4924 6.61654 28.9509 14.5545 28.9509C18.1983 28.9509 21.5284 27.5872 24.0671 25.3468C24.4777 27.6731 26.5091 29.4474 28.951 29.4474C29.2255 29.4474 29.4474 29.2255 29.4474 28.9509C29.4474 28.6764 29.2255 28.4545 28.951 28.4545ZM1.15082 14.5544C1.15082 7.16354 7.1636 1.15076 14.5545 1.15076C21.9454 1.15076 27.9581 7.16354 27.9581 14.5544C27.9581 21.9453 21.9454 27.9581 14.5545 27.9581C7.1636 27.9581 1.15082 21.9453 1.15082 14.5544Z"
        fill="url(#paint0_linear_373_1401)"
      />
      <path
        d="M14.5548 2.14374C7.71152 2.14374 2.14404 7.71122 2.14404 14.5545C2.14404 21.3978 7.71152 26.9653 14.5548 26.9653C21.3981 26.9653 26.9656 21.3978 26.9656 14.5545C26.9656 7.71122 21.3981 2.14374 14.5548 2.14374ZM14.5548 5.12233C16.4706 5.12233 18.0299 6.68162 18.0299 8.59735C18.0299 10.5131 16.4706 12.0724 14.5548 12.0724C12.6391 12.0724 11.0798 10.5131 11.0798 8.59735C11.0798 6.68162 12.6391 5.12233 14.5548 5.12233ZM8.59766 18.0296C6.68193 18.0296 5.12263 16.4703 5.12263 14.5545C5.12263 12.6388 6.68193 11.0795 8.59766 11.0795C10.5134 11.0795 12.0727 12.6388 12.0727 14.5545C12.0727 16.4703 10.5134 18.0296 8.59766 18.0296ZM14.5548 23.9867C12.6391 23.9867 11.0798 22.4274 11.0798 20.5117C11.0798 18.596 12.6391 17.0367 14.5548 17.0367C16.4706 17.0367 18.0299 18.596 18.0299 20.5117C18.0299 22.4274 16.4706 23.9867 14.5548 23.9867ZM20.512 18.0296C18.5963 18.0296 17.037 16.4703 17.037 14.5545C17.037 12.6388 18.5963 11.0795 20.512 11.0795C22.4277 11.0795 23.987 12.6388 23.987 14.5545C23.987 16.4703 22.4277 18.0296 20.512 18.0296Z"
        fill="url(#paint1_linear_373_1401)"
      />
      <path
        d="M14.5549 11.0794C15.9424 11.0794 17.105 10.1292 17.4362 8.84492C16.5818 8.37182 15.6004 8.10077 14.5549 8.10077C13.5094 8.10077 12.5279 8.37182 11.6736 8.84492C12.0047 10.1292 13.1673 11.0794 14.5549 11.0794Z"
        fill="url(#paint2_linear_373_1401)"
      />
      <path
        d="M14.5549 18.0295C13.1673 18.0295 12.0047 18.9797 11.6736 20.2639C12.5279 20.737 13.5094 21.0081 14.5549 21.0081C15.6004 21.0081 16.5818 20.737 17.4362 20.2639C17.105 18.9797 15.9424 18.0295 14.5549 18.0295Z"
        fill="black"
      />
      <path
        d="M18.0295 14.5544C18.0295 15.9419 18.9797 17.1045 20.264 17.4352C20.7371 16.5813 21.0081 15.5999 21.0081 14.5544C21.0081 13.5089 20.7371 12.5274 20.264 11.6736C18.9797 12.0042 18.0295 13.1669 18.0295 14.5544Z"
        fill="url(#paint3_linear_373_1401)"
      />
      <path
        d="M8.84498 11.6736C8.37188 12.5274 8.10083 13.5089 8.10083 14.5544C8.10083 15.5999 8.37188 16.5813 8.84498 17.4352C10.1293 17.1045 11.0794 15.9419 11.0794 14.5544C11.0794 13.1669 10.1293 12.0042 8.84498 11.6736Z"
        fill="url(#paint4_linear_373_1401)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_373_1401"
          x1="-4.58726"
          y1="9.92105"
          x2="32.4644"
          y2="7.16107"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#030303" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_373_1401"
          x1="-1.87733"
          y1="10.4176"
          x2="29.5224"
          y2="8.07863"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#030303" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_373_1401"
          x1="10.74"
          y1="9.09363"
          x2="17.9211"
          y2="8.05874"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#030303" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_373_1401"
          x1="17.547"
          y1="13.5941"
          x2="21.3302"
          y2="13.4484"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#030303" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_373_1401"
          x1="7.61827"
          y1="13.5941"
          x2="11.4015"
          y2="13.4484"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#030303" />
        </linearGradient>
      </defs>
    </svg>
  );
}
